/**
 * Builds the OIDC/Auth0 redirect_uri from the CURRENT origin (whatever origin the flow is
 * already running on) plus the current path.
 *
 * The redirect_uri must exactly match an Auth0 Allowed Callback URL. Both
 * onboarding.sleepiodev.com and www.sleepiodev.com are registered, so using the current origin
 * keeps the user on a single origin across the Auth0 round-trip. That is what makes the
 * per-origin localStorage (oidcSessionToken, written before authorize and read back in the
 * callback) and the session cookie consistent — which was the only reason the previous
 * implementation force-rewrote the host to www.
 *
 * That www. rewrite (SLEEPIO-5818) moved the flow off onboarding. and broke the mobile
 * create-account handoff (SLEEPIO-5830/5831): the per-origin sessionStorage redirect_url was
 * dropped and the same-origin /api/handoff_token mint became cross-origin. Staying on the
 * current origin fixes both flows without an origin switch.
 */
export function buildCanonicalRedirectUri() {
  const { origin, pathname } = window.location;
  return `${origin}${pathname}`;
}
